<template>
  <div id="TranshipmentCards">
    <v-row class="text-uppercase">
      <v-col sm="12" md="6" lg="3">
        <v-card class="pa-4 d-flex align-center" color="#4caf50" dark>
          <div class="rounded-circle mr-3 card-icon">
            <v-icon class="pa-3" large color="white"> mdi-check </v-icon>
          </div>
          <div>
            <div class="caption">NFES Entregues no prazo</div>
            <v-progress-circular v-if="isLoading" class="ma-1" indeterminate color="white"></v-progress-circular>
            <span v-else class="display-1 font-weight-bold">{{ cardsData.onTime }}</span>
          </div>
        </v-card>
      </v-col>
      <v-col sm="12" md="6" lg="3">
        <v-card class="pa-4 d-flex align-center" color="#FF7F0E" dark>
          <div class="rounded-circle mr-3 card-icon">
            <v-icon class="pa-3" large color="white"> mdi-clock-check-outline </v-icon>
          </div>
          <div>
            <div class="caption">NFES Entregues em atraso</div>
            <v-progress-circular v-if="isLoading" class="ma-1" indeterminate color="white"></v-progress-circular>
            <span v-else class="display-1 font-weight-bold">{{ cardsData.late }}</span>
          </div>
        </v-card>
      </v-col>
      <v-col sm="12" md="6" lg="3">
        <v-card class="pa-4 d-flex align-center" color="#1F77B4" dark>
          <div class="rounded-circle mr-3 card-icon">
            <v-icon class="pa-3" large color="white"> mdi-progress-clock </v-icon>
          </div>
          <div>
            <div class="caption">NFES Abertas no prazo</div>
            <v-progress-circular v-if="isLoading" class="ma-1" indeterminate color="white"></v-progress-circular>
            <span v-else class="display-1 font-weight-bold">{{ cardsData.openOnTime }}</span>
          </div>
        </v-card>
      </v-col>
      <v-col sm="12" md="6" lg="3">
        <v-card class="pa-4 d-flex align-center" color="#D62728" dark>
          <div class="rounded-circle mr-3 card-icon">
            <v-icon class="pa-3" large color="white"> mdi-alert-circle-outline </v-icon>
          </div>
          <div>
            <div class="caption">NFES Abertas em atraso</div>
            <v-progress-circular v-if="isLoading" class="ma-1" indeterminate color="white"></v-progress-circular>
            <span v-else class="display-1 font-weight-bold">{{ cardsData.openLate }}</span>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'TranshipmentCards',
  props: {
    isLoading: {
      default: false,
      type: Boolean
    },
    cardsData: {
      default: () => {},
      type: Object
    }
  },
  data: () => ({})
};
</script>

<style lang="scss" scoped>
.card-icon {
  border: 1px solid;
}
</style>
